import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ConditionService } from '../../service/condition.service';
import { TabService } from '../tab/tab.service';
var MenuService = /** @class */ (function () {
    function MenuService(cond, tab) {
        this.cond = cond;
        this.tab = tab;
        this._changeSubject = new Subject();
        this.opens = {};
        this.menuId = 0;
        this.urls = [];
        this.menuState = {};
    }
    Object.defineProperty(MenuService.prototype, "changeObservable", {
        get: function () {
            return this._changeSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    MenuService.prototype.url = function (menu) {
        if (menu.next == null) {
            return '/';
        }
        var p = menu.next.page;
        if (typeof p !== 'undefined' && p !== null) {
            return "/" + menu.next.flow + "/" + p;
        }
        else {
            return "/" + menu.next.flow;
        }
    };
    MenuService.prototype.changeMenuCurrent = function (menus, name, url) {
        if (!menus || menus.length === 0 || !name) {
            if (this.menuId) {
                this.setOpenIds(menus, this.menuId);
            }
            return;
        }
        var ids = [];
        this.getMenuPathIds(menus, name, ids);
        for (var i = 0; i < ids.length; i++) {
            if (i === 0) { // current
                this.menuId = ids[i];
                this.setMenuState(url);
                this.setMenuCurrent(this.menuId);
                this.setMenuData();
                this._changeSubject.next();
            }
            else {
                this.setMenuOpenState('menu-' + ids[i], true);
            }
        }
    };
    MenuService.prototype.getMenuPathIds = function (menus, name, ids) {
        for (var _i = 0, menus_1 = menus; _i < menus_1.length; _i++) {
            var menu = menus_1[_i];
            if (menu.name === name || (menu.children && this.getMenuPathIds(menu.children, name, ids))) {
                ids.push(menu.id);
                return true;
            }
        }
        return false;
    };
    MenuService.prototype.setOpenIds = function (menus, id) {
        for (var _i = 0, menus_2 = menus; _i < menus_2.length; _i++) {
            var menu = menus_2[_i];
            if (menu.id === id) { // current
                return true;
            }
            if (menu.children && this.setOpenIds(menu.children, id)) {
                this.setMenuOpenState('menu-' + menu.id, true);
                return true;
            }
        }
        return false;
    };
    MenuService.prototype.setMenuCurrent = function (id) {
        this.setOpens();
        this.setMenuOpenState('menu-current', id);
    };
    MenuService.prototype.setMenuOpenState = function (key, val) {
        this.opens[key] = val;
        sessionStorage.setItem('menuOpenState', JSON.stringify(this.opens));
    };
    MenuService.prototype.getMenuOpenState = function (key) {
        this.setOpens();
        return this.opens[key];
    };
    MenuService.prototype.setOpens = function () {
        if (Object.keys(this.opens).length === 0) {
            var opens = sessionStorage.getItem('menuOpenState');
            this.opens = {};
            if (opens) {
                this.opens = JSOG.parse(opens);
            }
        }
    };
    MenuService.prototype.resetMenuOpenState = function () {
        this.opens = {};
        this.menuState = {};
        sessionStorage.removeItem('menuOpenState');
        sessionStorage.removeItem('menuScrollTop');
        sessionStorage.removeItem('breadcrumb');
    };
    MenuService.prototype.setMenu = function (id, url) {
        this.menuId = id;
        this.urls = [url];
        this.setMenuState(url);
        this.setMenuCurrent(this.menuId);
        this.setMenuData();
        this.cond.deleteCondition(url);
        this.tab.resetTab();
    };
    MenuService.prototype.pushUrl = function (url) {
        this.urls.push(url);
        this.setMenuState(url);
        this.setMenuData();
    };
    MenuService.prototype.popUrl = function () {
        this.urls.pop();
        this.setMenuData();
    };
    MenuService.prototype.setMenuState = function (url) {
        if (url && !url.match(/^\/(login|password|onetimelogin|$)/)) {
            this.menuState[url] = this.menuId;
        }
    };
    MenuService.prototype.setMenuData = function () {
        sessionStorage.setItem('breadcrumb', JSON.stringify({ menuId: this.menuId, urls: this.urls, state: this.menuState }));
    };
    MenuService.prototype.getMenuData = function (menus) {
        return { menupath: this.getMenuPath(menus), back: this.urls.length > 1 ? true : false };
    };
    MenuService.prototype.checkMenuData = function (url) {
        if (!this.menuId && this.urls.length === 0) {
            var breadcrumb = sessionStorage.getItem('breadcrumb');
            if (breadcrumb) {
                var data = JSOG.parse(breadcrumb);
                this.menuId = data.menuId;
                this.urls = data.urls;
                this.menuState = data.state;
            }
            this.setMenuCurrent(this.menuId);
        }
        if (typeof this.menuState[url] !== 'undefined') {
            if (this.urls[this.urls.length - 1] !== url) {
                this.setMenu(this.menuState[url], url);
            }
            else if (this.menuId !== this.menuState[url]) {
                this.menuId = this.menuState[url];
                this.setMenuCurrent(this.menuId);
            }
        }
        else if (this.urls[this.urls.length - 1] !== url) {
            this.setMenu(0, url);
        }
    };
    MenuService.prototype.getMenuPath = function (menus) {
        var menupath = [];
        var paths = jsonpath.paths(menus, '$..[?(@.id==' + this.menuId + ')]')[0];
        if (!paths) {
            return [];
        }
        while (paths.length) {
            var val = jsonpath.value(menus, jsonpath.stringify(paths));
            if (Object.prototype.toString.call(val) !== '[object Array]' && val.title) {
                menupath.unshift({ label: val.title, url: (typeof val.next !== 'undefined' ? this.url(val) : '') });
            }
            paths.pop();
        }
        return menupath;
    };
    MenuService.prototype.setMenuScrollTop = function (scrollTop) {
        sessionStorage.setItem('menuScrollTop', scrollTop.toString());
    };
    MenuService.prototype.getMenuScrollTop = function () {
        var scrollTop = sessionStorage.getItem('menuScrollTop');
        if (typeof scrollTop === 'string') {
            return parseInt(scrollTop);
        }
        return 0;
    };
    MenuService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MenuService.ctorParameters = function () { return [
        { type: ConditionService },
        { type: TabService }
    ]; };
    return MenuService;
}());
export { MenuService };
//# sourceMappingURL=menu.service.js.map